import {getSize} from 'helpers/getSize';
import * as React from 'react';
import {useColorScheme, useWindowDimensions} from 'react-native';
import {DEVICE_SIZES} from 'rn-responsive-styles';
import {Colors, Images, Typography} from '../styles';

export interface ITheme {
  isDark: boolean;
  colors: Colors.IColor;
  images: Images.IImage;
  typography: Typography.ITypography;
  isWebSize: boolean;
}

export const ThemeContext = React.createContext({
  isDark: false,
  colors: Colors.light,
  images: Images.light,
  typography: Typography.light,
  isWebSize: false,
});

export interface ThemeProviderProps {
  children: JSX.Element | JSX.Element[];
}

export const ThemeProvider = (props: ThemeProviderProps) => {
  const colorScheme = useColorScheme();
  const isDark = colorScheme === 'dark';
  const width = useWindowDimensions().width;

  const defaultTheme = {
    isDark,
    colors: isDark ? Colors.dark : Colors.light,
    images: isDark ? Images.dark : Images.light,
    typography: isDark ? Typography.dark : Typography.light,
    isWebSize: width > getSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE),
  };

  return (
    <ThemeContext.Provider value={defaultTheme}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => React.useContext(ThemeContext);
